export default __webpack_public_path__ + "static/media/Preloader.6c9eecd1.gif";